import React from 'react';
import { css } from '@emotion/react';
import { withEuiTheme } from '../../../../src/services';
import { EuiIcon } from '../../../../src/components/icon';
import { EuiText } from '../../../../src/components/text'; // eslint-disable-next-line react/prefer-stateless-function

class Block extends React.Component {
  render() {
    const {
      theme
    } = this.props;
    const divStyle = /*#__PURE__*/css("background:", theme.euiTheme.colors.lightShade, ";padding:", theme.euiTheme.size.xl, ";border-radius:", theme.euiTheme.border.radius.medium, ";;label:Block;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9hcHAvc3JjLWRvY3Mvc3JjL3ZpZXdzL3RoZW1lL2NvbnN1bWluZ19ob2MudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQVd3QiIsImZpbGUiOiIvYXBwL3NyYy1kb2NzL3NyYy92aWV3cy90aGVtZS9jb25zdW1pbmdfaG9jLnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyBjc3MgfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5pbXBvcnQgeyB3aXRoRXVpVGhlbWUsIFdpdGhFdWlUaGVtZVByb3BzIH0gZnJvbSAnLi4vLi4vLi4vLi4vc3JjL3NlcnZpY2VzJztcbmltcG9ydCB7IEV1aUljb24gfSBmcm9tICcuLi8uLi8uLi8uLi9zcmMvY29tcG9uZW50cy9pY29uJztcbmltcG9ydCB7IEV1aVRleHQgfSBmcm9tICcuLi8uLi8uLi8uLi9zcmMvY29tcG9uZW50cy90ZXh0JztcblxuLy8gZXNsaW50LWRpc2FibGUtbmV4dC1saW5lIHJlYWN0L3ByZWZlci1zdGF0ZWxlc3MtZnVuY3Rpb25cbmNsYXNzIEJsb2NrIGV4dGVuZHMgUmVhY3QuQ29tcG9uZW50PFdpdGhFdWlUaGVtZVByb3BzPiB7XG4gIHJlbmRlcigpIHtcbiAgICBjb25zdCB7IHRoZW1lIH0gPSB0aGlzLnByb3BzO1xuXG4gICAgY29uc3QgZGl2U3R5bGUgPSBjc3NgXG4gICAgICBiYWNrZ3JvdW5kOiAke3RoZW1lLmV1aVRoZW1lLmNvbG9ycy5saWdodFNoYWRlfTtcbiAgICAgIHBhZGRpbmc6ICR7dGhlbWUuZXVpVGhlbWUuc2l6ZS54bH07XG4gICAgICBib3JkZXItcmFkaXVzOiAke3RoZW1lLmV1aVRoZW1lLmJvcmRlci5yYWRpdXMubWVkaXVtfTtcbiAgICBgO1xuXG4gICAgcmV0dXJuIChcbiAgICAgIDxFdWlUZXh0IGNzcz17ZGl2U3R5bGV9PlxuICAgICAgICA8cD5cbiAgICAgICAgICA8RXVpSWNvbiB0eXBlPVwiZmFjZUhhcHB5XCIgLz4gVGhpcyBib3ggaGFzIGl0JmFwb3M7cyBiYWNrZ3JvdW5kLFxuICAgICAgICAgIHBhZGRpbmcsIGFuZCBib3JkZXItcmFkaXVzIGNvbnRyb2xsZWQgYnkgY3VzdG9tIGNzc1xuICAgICAgICA8L3A+XG4gICAgICA8L0V1aVRleHQ+XG4gICAgKTtcbiAgfVxufVxuXG5leHBvcnQgY29uc3QgQ29uc3VtaW5nSE9DID0gd2l0aEV1aVRoZW1lKEJsb2NrKTtcbiJdfQ== */"));
    return <EuiText css={divStyle}>
        <p>
          <EuiIcon type="faceHappy" /> This box has it&apos;s background,
          padding, and border-radius controlled by custom css
        </p>
      </EuiText>;
  }

}

export const ConsumingHOC = withEuiTheme(Block);

try {
  ConsumingHOC.__docgenInfo = {
    tags: {},
    filePath: '/app/src-docs/src/views/theme/consuming_hoc.tsx',
    description: '',
    displayName: 'ConsumingHOC',
    methods: [],
    props: {
      ref: {
        defaultValue: null,
        description: '',
        name: 'ref',
        parent: {
          fileName: 'app/node_modules/@types/react/index.d.ts',
          name: 'RefAttributes'
        },
        declarations: [{
          fileName: 'app/node_modules/@types/react/index.d.ts',
          name: 'RefAttributes'
        }],
        required: false,
        type: {
          name: 'Ref<unknown>'
        }
      }
    },
    extendedInterfaces: ['Attributes']
  };
} catch (e) {}